import { useEffect, useState } from "react";

// Below Tailwind's `md` (768px) the files list shows cards instead of rows.
export const PHONE_QUERY = "(max-width: 767.98px)";

function matchesPhone(): boolean {
  return typeof window.matchMedia === "function" && window.matchMedia(PHONE_QUERY).matches;
}

/** True while the viewport is narrower than Tailwind's `md` breakpoint. */
export default function useIsPhone(): boolean {
  const [isPhone, setIsPhone] = useState(matchesPhone);

  useEffect(() => {
    if (typeof window.matchMedia !== "function") return undefined;
    const query = window.matchMedia(PHONE_QUERY);
    const onChange = () => setIsPhone(query.matches);
    query.addEventListener("change", onChange);
    return () => query.removeEventListener("change", onChange);
  }, []);

  return isPhone;
}
